<div mat-dialog-title><mat-icon class="title align-middle">business</mat-icon>{{ dialogTitle | translate:locale.language }}</div>
<div mat-dialog-content>
  <ng-container *ngIf="facility; else loading">
    <div id="facility-name" class="row-item" *ngIf="facility.name">
      <span class="summary-label"><mat-icon>business</mat-icon>{{ ('Name') | translate:locale.language}}:</span>
      <div>{{ facility.name }}</div>
    </div>
    <div id="facility-type" class="row-item" *ngIf="facility.typeAttr?.value">
      <span class="summary-label"><mat-icon>info_outline</mat-icon>{{ (facility.typeAttr?.name ?? 'Type') | translate:locale.language}}:</span>
      <div>{{ facility.typeAttr?.value }}</div>
    </div>
    <div id="facility-brand" class="row-item" *ngIf="facility.brandAttr?.value">
      <span class="summary-label"><mat-icon>info_outline</mat-icon>{{ (facility.brandAttr?.name ?? 'Brand') | translate:locale.language}}:</span>
      <div>{{ facility.brandAttr?.value }}</div>
    </div>
    <div id="facility-brand-groups" class="row-item" *ngIf="facility.brandGroupsAttr?.value">
      <span class="summary-label"><mat-icon>info_outline</mat-icon>{{ (facility.brandGroupsAttr?.name ?? 'Brand Groups') | translate:locale.language}}:</span>
      <div>{{ facility.brandGroupsAttr?.value }}</div>
    </div>
    <div id="facility-phone" class="row-item" *ngIf="facility.phoneNumber">
      <span class="summary-label"><mat-icon>local_phone</mat-icon>{{ 'Phone' | translate:locale.language}}:</span>
      <div>
        <a href="{{ 'tel:' + facility.phoneNumber | phone }}" target="_blank" rel="noopener">{{ facility.phoneNumber | phone }}
          <span class="popup"><mat-icon>open_in_new</mat-icon></span>
        </a>
      </div>
    </div>

    <div id="facility-address" class="row-item" *ngIf="addressQuery && addressParts?.length">
      <span class="summary-label"><mat-icon>location_on</mat-icon>{{ 'Location' | translate:locale.language}}:</span>
      <div>
        <a href="{{ addressQuery }}" target="_blank" rel="noopener">
          <span *ngFor="let part of addressParts; let i = index">{{ part }}
            <span class="popup" *ngIf="i === 0"><mat-icon>open_in_new</mat-icon></span><br>
          </span>
        </a>
      </div>
    </div>

    <div id="facility-region" class="row-item" *ngIf="facility.region">
      <span class="summary-label"><mat-icon>info_outline</mat-icon>{{ ('Region') | translate:locale.language}}:</span>
      <div>{{ facility.region }}</div>
    </div>
    <div id="facility-area" class="row-item" *ngIf="facility.areaAttr?.value">
      <span class="summary-label"><mat-icon>info_outline</mat-icon>{{ (facility.areaAttr?.name ?? 'Area') | translate:locale.language}}:</span>
      <div>{{ facility.areaAttr?.value }}</div>
    </div>
    <div id="facility-area" class="row-item" *ngIf="facility.area">
      <span class="summary-label"><mat-icon>info_outline</mat-icon>{{ ('Area') | translate:locale.language}}:</span>
      <div>{{ facility.area }}</div>
    </div>
    <div id="facility-sub-area" class="row-item" *ngIf="facility.subAreaAttr?.value">
      <span class="summary-label"><mat-icon>info_outline</mat-icon>{{ (facility.subAreaAttr?.name ?? 'Sub Area') | translate:locale.language}}:</span>
      <div>{{ facility.subAreaAttr?.value }}</div>
    </div>
  </ng-container>
  <ng-template #loading>
    <div class="row">
      <app-loading [hasFailed]="!!loadError" [failTitle]="loadError" [hideRetry]="hideRetry" (retryClicked)="loadAsset()"></app-loading>
    </div>
  </ng-template>
</div>
<div mat-dialog-actions align="end">
  <button mat-button color="primary" id="closeFacility" mat-dialog-close="">{{ 'Close' | translate:locale.language }}</button>
</div>